var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24CheckCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40015 23.7431V9.07613C5.40015 7.41927 6.74329 6.07613 8.40015 6.07613H15.7332V8.07613H8.40015C7.84786 8.07613 7.40015 8.52384 7.40015 9.07613V23.7431C7.40032 24.2953 7.84797 24.7431 8.40015 24.7431H23.0671C23.6192 24.7429 24.067 24.2951 24.0671 23.7431V16.4091H26.0671V23.7431C26.067 25.3997 24.7237 26.7429 23.0671 26.7431H8.40015C6.7434 26.7431 5.40032 25.3998 5.40015 23.7431Z",
    fill: "#A4ACB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2593 12.4651L17.188 19.5374C17.0275 19.6979 16.8244 19.8097 16.603 19.8596L12.2769 20.8352C11.6965 20.9661 11.1773 20.4469 11.3081 19.8665L12.2837 15.5403C12.3336 15.3189 12.4455 15.1158 12.606 14.9554L19.6772 7.88309L24.2593 12.4651ZM22.0972 5.46414C22.4135 5.14782 22.9264 5.14782 23.2427 5.46414L26.6792 8.90067C26.9955 9.217 26.9955 9.72987 26.6792 10.0462L25.3198 11.4046L20.7378 6.82254L22.0972 5.46414Z",
    fill: "#A4ACB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24CheckCircleFill);
export default __webpack_public_path__ + "static/media/24_check_circle_fill.ed55fb6b30f46c6f6c215c6f9e4fd94d.svg";
export { ForwardRef as ReactComponent };